export default "__VITE_ASSET__9a517932__"